module.exports = __webpack_public_path__ + "img/weekly-logo.233bce2b.png";